import { faBoxOpen, faChevronRight, faEye, faPen, faPlus, faTrashAlt, faFilePdf, faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component, createRef } from 'react';
import axios from "axios";
import apiUrl from "../apiUrlConstant";
import { withRouter } from 'react-router-dom';
import TaskAddComp from "./TaskAdd";
import CommentSection from "./CommentAdd";
import UpdateStatus from "./UpdateLeadStatus";
import AttachmentFile from "./AttachmentAdd";
import LeadStatusUpdate from "./LeadStatusUpdate";
import { Modal } from "react-bootstrap";
import { fileUploadPath, getUserStorageType, numberFormat, capitalizeFirstLetter } from "../utils/index";
import { ViewLeasePdfReader } from "../utils/ViewLeaseDocumentViewer";
import { PopupMessage } from "../utils/utils";
import { Link } from "react-router-dom";
import moment from "moment";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};


class LeadDetails extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showTaskModal: false,
      addSection: '',
      taskId: '',
      data: {
        tasks: [],
        contacts: [],
        history: [],
        attachments: []
      },
      modalTitle:'',
      documentViewer:false,
      pageNo:1,
      currentDocument:'',
      popupContent: "",
      messsagePopup: false,
    };

    this.handleModal = this.handleModal.bind(this);
    this.closeTaskModel = this.closeTaskModel.bind(this);
    this.closeDocumentViewer = this.closeDocumentViewer.bind(this);
    this.deleteAttachment = this.deleteAttachment.bind(this);
    this.handleRedirect = this.handleRedirect.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {

    const { id } = this.props.match.params;
    this.setState({ taskId: id });

    axios.get(`${apiUrl.apiUrl.url}/leads/get?id=${id}`, { headers })
      .then(response => {
        this.setState({ data: response.data.data });
      })
      .catch(error => {
        if (error.response) {
          console.error("There was an error fetching the lead details!", error.response.data);
        } else if (error.request) {
          console.error("The request was made but no response was received", error.request);
        } else {
          console.error("Something went wrong in setting up the request", error.message);
        }
      });
  }

  handleModal(type, title) {
    this.setState({ 
      addSection: type, 
      showTaskModal: true,
      modalTitle: title 
    });
  }

  closeTaskModel() {
    this.fetchData();
    this.setState({ showTaskModal: false });
  }

  closeDocumentViewer(){
    this.setState({ documentViewer: false });
  }

  deleteAttachment(id){

    var self = this;
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/leads/delete-attachment`,
      data: {id:id},
    }).then(function (response) {
      if (response.status='success') {
        self.setState({ 
          messsagePopup: true ,
          popupContent: "Attachment Deleted Successfully!"
        });

        self.fetchData();

      } else {
        self.setState({ 
          messsagePopup: true ,
          popupContent: response.message
        });
      }
    });
  }

  handleRedirect() {
    this.setState({ 
      messsagePopup: false,
      popupContent:"",
    });
  }

  render() {
    // Helper function to get initials
    const getInitials = (name) => {
      if (!name) return '';

      const parts = name.split(' ');
      if (parts.length === 1) {
        return parts[0].slice(0, 2); // First two characters if single name
      } else {
        return parts[0].charAt(0) + parts[parts.length - 1].charAt(0); // First characters of first and last name
      }
    };

    // Helper function to format date (assuming comment.created_on is a valid date string)
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      //return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
      return moment(date).format("DD-MMM-YYYY");
    };

    // Helper function to format time (assuming comment.created_on is a valid date string)
    const formatTime = (dateString) => {
      const date = new Date(dateString);
      let hours = date.getHours();
      const minutes = date.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // Handle midnight (0 hours)
      const minutesStr = minutes < 10 ? `0${minutes}` : minutes;
      return `${hours}:${minutesStr} ${ampm}`;
    };
    

    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <Link to={`/leads`} style={{ color: "#000", textDecoration: "none" }} >
                <li>Lead</li>
              </Link>

              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <a href="#">Lead Details</a>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <a href="#">{this.state.data.title}</a>
              </li>
            </ul>
          </div>
        </div>
        <div className='leadDetailsMain'>
          <div className="leadDetailsParent row m-0">
            <div className="leadDetailsParentL col-sm-8 ps-0">
              <div className="bgWithPadding py-0">
              {this.state.data.history.length > 0 &&
                <div className="timelineForLeadDashboard">
                  <ul className="sessions">
                    { this.state.data.history.map((history, index) => (
                    <li key={index}>
                      <h6>{index+1}</h6>
                      <em>{history.stage} | {history.sub_stage}</em>
                      <p>{formatDate(history.created_on)} | {formatTime(history.created_on)}</p>
                    </li>
                    ))
                    }
                  </ul>
                </div>
              }

                
              </div>
              <div className="detailaPageTaskListTable bgWithPadding mt-3">
                <div className="d-flex justify-content-between align-items-center gap-2 mb-3">
                  <h5>Task</h5>
                  <div className='button_group d-flex justify-content-end align-items-center gap-2 w-100'>
                    <button className="add_button mr-2" onClick={() => this.handleModal('task','Add Task')}>
                      <FontAwesomeIcon icon={faPlus} /> Task
                    </button>
                    <button className="update_button big_button" onClick={() => this.handleModal('status','Update Stage')}>
                      <FontAwesomeIcon icon={faPlus} /> Update Stage
                    </button>
                    <button className="add_button big_button" onClick={() => this.handleModal('comment','Add Comment')}>
                      <FontAwesomeIcon icon={faPlus} /> Comment
                    </button>
                    <Link to={`/leads/edit/${this.state.taskId}`}>
                      <button className="update_button big_button" >
                        <FontAwesomeIcon icon={faEdit} /> Edit Lead
                      </button>
                    </Link>
                    <button className="add_button big_button" onClick={() => this.handleModal('lead_status','Update Status')}>
                      <FontAwesomeIcon icon={faPlus} /> Update Status
                    </button>
                    
                  </div>
                </div>
                <table className='w-100'>
                  <thead>
                    <tr>
                      <th>Task</th>
                      <th>Assign to</th>
                      <th>Status</th>
                      <th>Due Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.data.tasks && this.state.data.tasks.length > 0 ? (
                      this.state.data.tasks.reverse().map((task, index) => (
                        <tr key={index}>
                          <td>{task.title}</td>
                          <td>{task.user ? task.user.name : 'Unassigned'}</td>
                          <td>{task.status}</td>
                          <td><span className="date">{formatDate(task.due_date)}</span></td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" style={{ textAlign: 'center', padding: '20px' }} >No record found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="detailsPageUpdates bgWithPadding mt-3">
                <div className="mb-3">
                  <h5>Comments</h5>
                </div>
                <div className="d-grid gap-3">
                  {this.state.data.lead_comments && this.state.data.lead_comments.length > 0 ? (
                    this.state.data.lead_comments.reverse().map((comment, index) => (
                      <div className="detailsPageUpdatesCard" key={index}>
                        <div className="updatesCardName d-flex align-items-center gap-2">
                          <span title={comment.user.name}>{getInitials(comment.user.name)}</span>
                          <div>
                            <h3>{comment.comment}</h3>
                            <p>{formatDate(comment.created_on)} | {formatTime(comment.created_on)}</p>
                          </div>
                        </div>
                        {/* <h4>Comment: {comment.comment}</h4> */}
                      </div>
                    ))
                  ) : (
                    <div className="detailsPageUpdatesCard">
                      <p>No comments found.</p>
                    </div>
                  )}
                </div>
              </div>

              <div className="detailsPageUpdates bgWithPadding mt-3">
                <div className="mb-3">
                  <h5>COMPANY</h5>
                </div>
                <div className="d-grid gap-3">
                  <div className="requirementsDetsils">
                    <div className="requirementsDetsilsInner">
                      <span>Tenant</span>
                      <p>{this.state.data.tenant}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Tenant Industry</span>
                      <p>{this.state.data.tenant_industry}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Tenant Status</span>
                      <p>{this.state.data.tenant_status}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Hot Prospect</span>
                      <p>{this.state.data.is_hot_prospect && this.state.data.is_hot_prospect==1 ?'Yes':'No'}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Lead Status</span>
                      <p>
                        {this.state.data.lead_temperature === 'hot' ?<button className="btn btn-danger"><i className="fas fa-fire"></i> Hot</button>: 
                        this.state.data.lead_temperature === 'warm' ? <button className="btn btn-warning"><i className="fas fa-thermometer-half"></i> Warm</button> : 
                        this.state.data.lead_temperature === 'cold' ? <button className="btn btn-info"><i className="fas fa-snowflake"></i> Cold </button> : 
                        <button className="btn btn-secondary"><i className="fas fa-snowflake"></i> {this.state.data.lead_temperature} </button>
                        }
                      </p>
                    </div>
                  </div>

                </div>
              </div>
              <div className="detailsPageUpdates bgWithPadding mt-3">
                <div className="mb-3">
                  <h5>DEAL INFORMATION</h5>
                </div>
                <div className="d-grid gap-3">
                  <div className="requirementsDetsils">
                    <div className="requirementsDetsilsInner">
                      <span>Stage</span>
                      <p>{this.state.data.leadSubStage?capitalizeFirstLetter(this.state.data.leadSubStage.stage):''}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Sub Stage</span>
                      <p>{this.state.data.leadSubStage?capitalizeFirstLetter(this.state.data.leadSubStage.title):''}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Winning Probability(%)</span>
                      <p>{this.state.data.leadSubStage?this.state.data.leadSubStage.winning_probability:''}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Requirement Type</span>
                      <p>{this.state.data.requirement_type}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Tags</span>
                      <p>{this.state.data.tags}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Reference Source</span>
                      <p>{this.state.data.reference_source}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Comment</span>
                      <p>{this.state.data.comment}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="detailsPageUpdates bgWithPadding mt-3">
                <div className="mb-3">
                  <h5>CURRENT LOCATION</h5>
                </div>
                <div className="d-grid gap-3">
                  <div className="requirementsDetsils">
                    <div className="requirementsDetsilsInner">
                      <span>Current Address</span>
                      <p>{this.state.data.current_address}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Floor | Space</span>
                      <p>{this.state.data.floor}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Lease Expiration</span>
                      <p>{this.state.data.lease_expiry ? formatDate(this.state.data.lease_expiry) : ''}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Current Area (sqft)</span>
                      <p>{numberFormat(this.state.data.current_area)}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Current Rent (INR / psf)</span>
                      <p>{numberFormat(this.state.data.current_rent)}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="detailsPageUpdates bgWithPadding mt-3">
                <div className="mb-3">
                  <h5>Requirements</h5>
                </div>
                <div className="d-grid gap-3">
                  <div className="requirementsDetsils">
                   <div className="requirementsDetsilsInner">
                      <span>Area Type</span>
                      <p>{this.state.data.area_type}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Requested Sqft (From)</span>
                      <p>{numberFormat(this.state.data.requested_sqft_from)}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Requested Sqft (To)</span>
                      <p>{numberFormat(this.state.data.requested_sqft_to)}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Target Price (From)</span>
                      <p>{numberFormat(this.state.data.target_price_from)}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Target Price (To)</span>
                      <p>{numberFormat(this.state.data.target_price_to)}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>Targeted Markets</span>
                      <p>{this.state.data.targeted_markets}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="detailsPageUpdates bgWithPadding mt-3 mb-4">
                <div className="mb-3">
                  <h5>COMMISSION</h5>
                </div>
                <div className="d-grid gap-3">
                  <div className="requirementsDetsils">
                    <div className="requirementsDetsilsInner">
                      <span>Total Commission</span>
                      <p>{this.state.data.total_commission}</p>
                    </div>
                    <div className="requirementsDetsilsInner">
                      <span>My % Split</span>
                      <p>{this.state.data.my_split}</p>
                    </div>
                  </div>
                </div>
              </div>


            </div>
            <div className="leadDetailsParentR col-sm-4 pe-0">
              <div className="bgWithPadding">
                {/* <div className="mb-3"> */}
                  <h5>History</h5>
                {/* </div> */}
                <div className="d-grid-gap-2 maxHeightDiv">
                  {this.state.data.history.length > 0 ? (
                    this.state.data.history.reverse().map((history, index) => (
                      <div className="historyDetailsDiv" key={index}>
                        <em>{history.stage} | {history.sub_stage}</em>
                        <p>{history.comment}</p>
                        <h5><span>{history.createdBy.name}</span> | <span>{formatDate(history.created_on)} | {formatTime(history.created_on)}</span></h5>
                      </div>
                    ))
                  ) : (
                    <div className="detailsPageUpdatesCard">
                      <p>No History Found.</p>
                    </div>
                  )}

                </div>
              </div>

              <div className="bgWithPadding mt-3">
                <div className="">
                  <div className='d-flex justify-content-between align-items-center gap-2'>
                  <h5 onClick={() => this.handleModal('attachment','Upload Attachment')} >Attachment {this.state.data.attachments.length > 0 ? `(${this.state.data.attachments.length})` : ''}</h5>
                    <div className="button_group">
                    <button className="add_button" onClick={() => this.handleModal('attachment','Add Attachment')}>
                        <FontAwesomeIcon icon={faPlus} /> Upload
                    </button>
                  </div>
                  </div>
                </div>
                <div className="d-grid-gap-2 maxHeightDiv">
                  {this.state.data.attachments.length > 0 ? (
                    this.state.data.attachments.reverse().map((attachment, index) => (
                      <div className="detialsPageContactsCard" key={index}>
                        <span className='bold'>
                          {attachment.title}
                        </span>
                        <br />
                        
                        
                          <div className="d-flex justify-content-between align-items-center gap-2">
                          {attachment.user.name ? 
                          <a href="#">Added By: {attachment.user.name} </a>
                          : <a href="#"></a>
                          }
                          <div className='d-flex justify-content-between align-items-center gap-2'>
                            {attachment.extension ==='pdf'?
                              <span onClick={()=>{this.setState({documentViewer: true, currentDocument: attachment.url});}}><FontAwesomeIcon icon={faFilePdf} color='#5F6368' /></span>
                            : <span onClick={()=>{ window.location.href=attachment.url;}}><FontAwesomeIcon icon={faEye} color='#5F6368' /></span>
                            }
                            <span onClick={ ()=>{this.deleteAttachment(attachment.id)}}><FontAwesomeIcon icon={faTrashAlt} color='#5F6368' /></span>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="detialsPageContactsCard">
                      <p>No Attachment added.</p>
                    </div>
                  )}
                </div>
              </div>

              <div className="bgWithPadding mt-3">
                <div className="mb-3">
                  <h5>Contacts {this.state.data.contacts.length > 0 ? `(${this.state.data.contacts.length})` : ''}</h5>
                </div>
                <div className="d-grid-gap-2">
                  {this.state.data.contacts.length > 0 ? (
                    this.state.data.contacts.map((contact, index) => (
                      <div className="detialsPageContactsCard" key={index}>
                        <span className='bold'>
                          {contact.first_name && contact.last_name
                            ? `${contact.first_name} ${contact.last_name}`
                            : getInitials(contact.first_name)}
                        </span> | {contact.title}
                        <br />
                        {contact.email && <a href={`mailto:${contact.email}`}>{contact.email}</a>}

                        <div className="d-flex justify-content-between align-items-center gap-2">
                          {contact.phone_no ?
                            <a href={`tel:${contact.phone_no}`}>Mobile ( {contact.phone_no} )</a>
                            : <a href="#"></a>
                          }
                          <div className='d-flex justify-content-between align-items-center gap-2'>
                            <Link to={`/leads/edit/${this.state.taskId}`}>
                              <span><FontAwesomeIcon icon={faPen} color='#5F6368' /></span>
                            </Link>
                            {/* <span><FontAwesomeIcon icon={faTrashAlt} color='#5F6368' /></span> */}
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="detialsPageContactsCard">
                      <p>No contacts added.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal className="customModalFroTaskAndComment" show={this.state.showTaskModal} onHide={this.closeTaskModel} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title> {this.state.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.addSection === 'task' ? (
              <TaskAddComp closeModal={this.closeTaskModel} leadId={this.state.taskId} />
            ) : this.state.addSection === 'comment' ? (
              <CommentSection closeModal={this.closeTaskModel} leadId={this.state.taskId} />
            ) : this.state.addSection==='status'? (
              <UpdateStatus closeModal={this.closeTaskModel} leadId={this.state.taskId} stage={this.state.data.leadSubStage.stage} sub_stage={this.state.data.leadSubStage.title} sub_stage_id={this.state.data.lm_lead_sub_stage_id} />
              ) : this.state.addSection === 'lead_status' ? (
                <LeadStatusUpdate closeModal={this.closeTaskModel} leadId={this.state.taskId} leadStatus = {this.state.data.lead_temperature} />
              ):
              ( 
              <AttachmentFile closeModal={this.closeTaskModel} leadId={this.state.taskId} />
            )}
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.documentViewer}
          onHide={this.closeDocumentViewer}
          size="lg"
          className="documentModal"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <div className="container modalBreadCrumbs">
                <div className="row">
                  <div className="col-lg-12">
                    <ul>
                      <li>Document</li>
                    </ul>
                  </div>
                </div>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="container">
              <div className="row">
                <ViewLeasePdfReader
                  url={this.state.currentDocument}
                  pageNumber={this.state.pageNo}
                />
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.handleRedirect}
        />

      </>
    );

  }
}

export default withRouter(LeadDetails);
